import { render, staticRenderFns } from "./investStatistics.vue?vue&type=template&id=107d2f57&"
import script from "./investStatistics.vue?vue&type=script&lang=js&"
export * from "./investStatistics.vue?vue&type=script&lang=js&"
import style0 from "./investStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports